import QueryString from './queryString'
import UtmNormalizer from './utmNormalizer'

const otherTrackingParams = ({ affiliate_id, gclid, lmdsid, xtra, trial_origin, referrer }) => ({
  affiliate_id,
  gclid,
  lmdsid,
  xtra,
  trial_origin,
  referrer,
})

export function getTrackingParams() {
  const params = {
    ...QueryString.getParams(window.location.search),
  }

  const mergedTrackingParams = {
    ...UtmNormalizer.call(params),
    ...otherTrackingParams(params),
  }

  return mergedTrackingParams
}

function setTrialOrigin(chooseSignup, tracking) {
  if (chooseSignup && (tracking.trial_origin === undefined || tracking.trial_origin === '(not set)')) {
    tracking.trial_origin = 'login_page'
  }
}

function createUrlSearchParams(tracking) {
  const urlSearchParams = new URLSearchParams()
  Object.entries(tracking).forEach(([key, value]) => {
    if (value) urlSearchParams.append(key, value)
  })
  return urlSearchParams.toString()
}

export function assembleTrackingParams(chooseSignup = false) {
  let tracking = getTrackingParams()
  setTrialOrigin(chooseSignup, tracking)
  return createUrlSearchParams(tracking)
}

const trackingParams = {
  getTrackingParams,
  assembleTrackingParams,
}

export default trackingParams
